import React, { useState } from 'react';
import { 
  FaUniversity, 
  FaHome, 
  FaPassport, 
  FaFileInvoiceDollar,
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaRocket,
  FaStar
} from 'react-icons/fa';
import './ServicesSection.css';

const ServicesSection = () => {
  const [activeService, setActiveService] = useState(null);

  const btgServices = [
    {
      icon: <FaUniversity />,
      title: 'Admission',
      subtitle: 'Dans les écoles françaises',
      description: 'Conseils, préparation de dossier, et accompagnement jusqu\'à l\'admission officielle dans l\'école qui correspond le mieux à votre profil.',
      features: [
        'Analyse de votre profil académique',
        'Sélection des établissements adaptés',
        'Préparation complète du dossier',
        'Suivi jusqu\'à l\'acceptation'
      ],
      color: '#073b8f'
    },
    {
      icon: <FaHome />,
      title: 'Logement',
      subtitle: 'Étudiant en france',
      description: 'Accès à un réseau de résidences et de logements étudiants à prix abordables, avec accompagnement administratif complet.',
      features: [
        'Réseau de résidences partenaires',
        'Accompagnement administratif',
        'Prix étudiants accessibles',
        'Localisation stratégique'
      ],
      color: '#c0264a'
    },
    {
      icon: <FaPassport />,
      title: 'Visa',
      subtitle: 'étudiant',
      description: 'Préparation complète du dossier, assistance à la prise de rendez-vous et accompagnement jusqu\'à la validation du visa.',
      features: [
        'Préparation du dossier visa',
        'Assistance aux rendez-vous',
        'Simulation d\'entretien',
        'Suivi jusqu\'à l\'obtention'
      ],
      color: '#073b8f'
    },
    {
      icon: <FaFileInvoiceDollar />,
      title: 'AVI',
      subtitle: 'Attestation de virement irrévocable',
      description: 'Nous facilitons votre demande d\'AVI auprès d\'établissements reconnus pour garantir votre preuve de ressources.',
      features: [
        'Demande auprès d\'établissements reconnus',
        'Garantie de preuve de ressources',
        'Processus simplifié',
        'Accompagnement administratif'
      ],
      color: '#c0264a'
    }
  ];

  const toggleService = (index) => {
    setActiveService(activeService === index ? null : index);
  };

  return (
    <section className="btg-services-section-dark" id="btg-services">
      <div className="btg-container-dark">
        {/* En-tête de section - Style sombre premium */}
        <div className="btg-services-header-dark">
          <div className="btg-header-content-dark">
            <div className="btg-header-badge">
              <FaRocket className="btg-badge-icon" />
              <span>Services Premium</span>
            </div>
            <h1 className="btg-main-title-dark">Notre accompagnement</h1>
            <p className="btg-main-subtitle-dark">Sur mesure et garanti</p>
            <p className="btg-section-subtitle-dark">
              Un parcours complet et personnalisé pour concrétiser votre projet d'études en France
            </p>
            <div className="btg-header-decoration-dark">
              <div className="btg-decoration-line-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-glow-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-line-dark"></div>
            </div>
          </div>
        </div>

        {/* Section des services avec design sombre */}
        <div className="btg-services-horizontal-dark">
          <div className="btg-services-wrapper-dark">
            <div className="btg-services-cards-grid-dark">
              {btgServices.map((service, index) => (
                <div 
                  key={index} 
                  className={`btg-service-card-dark ${activeService === index ? 'btg-active-dark' : ''}`}
                  style={{ '--btg-accent-color': service.color }}
                  onClick={() => toggleService(index)}
                >
                  {/* Effet de lueur */}
                  <div className="btg-card-glow" style={{ '--glow-color': service.color }}></div>
                  
                  <div className="btg-service-card-header-dark">
                    <div className="btg-service-icon-container-dark">
                      <div className="btg-service-main-icon-dark">
                        {service.icon}
                      </div>
                      <div className="btg-icon-glow"></div>
                    </div>
                    <h3 className="btg-service-card-title-dark">{service.title}</h3>
                    <div className="btg-service-arrow-dark">
                      {activeService === index ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  </div>

                  {/* Contenu dépliable */}
                  <div className="btg-service-expandable-dark">
                    <div className="btg-service-content-dark">
                      <p className="btg-service-card-subtitle-dark">{service.subtitle}</p>
                      <p className="btg-service-card-description-dark">{service.description}</p>
                      
                      <div className="btg-service-features-dark">
                        <h4 className="btg-features-title-dark">
                          <FaStar className="btg-features-icon" />
                          Ce qui est inclus :
                        </h4>
                        <ul className="btg-features-list-dark">
                          {service.features.map((feature, featureIndex) => (
                            <li key={featureIndex} className="btg-feature-item-dark">
                              <FaCheckCircle className="btg-feature-check-dark" />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Section CTA sombre */}
        <div className="btg-services-cta-dark">
          <div className="btg-cta-content-dark">
            <div className="btg-cta-header-dark">
              <h3 className="btg-cta-title-dark">Prêt à transformer votre rêve en réalité ?</h3>
              <p className="btg-cta-subtitle-dark">Votre avenir en France commence ici</p>
            </div>
            <p className="btg-cta-text-dark">
              Rejoignez les centaines d'étudiants qui nous font confiance pour leur projet d'études en France
            </p>
            <button className="btg-cta-button-dark">
              <FaRocket className="btg-cta-icon" />
              Démarrer mon projet gratuitement
              <div className="btg-button-glow"></div>
            </button>
            
            <div className="btg-cta-stats-dark">
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">500+</div>
                <div className="btg-stat-label-dark">Étudiants accompagnés</div>
              </div>
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">95%</div>
                <div className="btg-stat-label-dark">Taux de réussite</div>
              </div>
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">98%</div>
                <div className="btg-stat-label-dark">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Background animé pour le CTA */}
          <div className="btg-cta-background-dark">
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
        <div className="btg-bg-element btg-bg-4"></div>
      </div>
    </section>
  );
};

export default ServicesSection;